import ConfirmationModalV3 from '@/Modals/NewConfirmationModal';
import React, { createContext, useContext, useRef } from 'react';

const ModalConfirmationContext = createContext();

export const ModalConfirmationProvider = ({ children }) => {
    const modalRef = useRef();

    const openModalConfirmation = (props) => {
        if (modalRef.current) {
            modalRef.current.open(props);
        }
    };

    return (
        <ModalConfirmationContext.Provider value={{ openModalConfirmation }}>
            {children}
            <ConfirmationModalV3 ref={modalRef} />
        </ModalConfirmationContext.Provider>
    );
};

export const useModalConfirmation = () => {
    return useContext(ModalConfirmationContext);
};